// Orquestrador › Agendamentos (backend: /api/v1/orquestrador/agendamentos).
// Rotinas automáticas por módulo. Hoje só o Simples Nacional.
import { api } from '../../../services/api';

const BASE = '/api/v1/orquestrador/agendamentos';

export type Modulo = 'simples_nacional';
export type Automacao = 'manual' | 'calcular' | 'transmitir';
export type StatusExecucao = 'rodando' | 'concluida' | 'falhou' | 'interrompida';

export interface IExecucao {
  id: number;
  rotina: string;
  competencia: string | null;
  disparo: 'agenda' | 'manual';
  status: StatusExecucao;
  iniciado_em: string;
  finalizado_em: string | null;
  batida_em: string | null;
  total: number;
  ok: number;
  falhas: number;
  puladas: number;
  erro: string | null;
  usuario_nome: string | null;
  resultados?: {
    empresa_id: number;
    nome?: string;
    competencia?: string;
    ok: boolean;
    erro?: string | null;
  }[];
  puladas_detalhe?: { empresa_id: number; nome: string; motivo: string; competencia?: string }[];
}

export interface IRotina {
  id: number;
  rotina: string;
  nome: string;
  descricao: string;
  transmite: boolean;
  usa_serpro: boolean;
  ativo: boolean;
  dias: string;
  hora: string;
  opcoes: { escopo?: 'todas' | 'automacao' };
  proxima: string | null;
  ultima: IExecucao | null;
  atualizado_por_nome: string | null;
  dt_atualizacao: string | null;
}

export interface IModuloAgendamentos {
  modulo: Modulo;
  ligado: boolean;
  atualizado_por_nome: string | null;
  dt_atualizacao: string | null;
  rotinas: IRotina[];
  automacao: { calcular: number; transmitir: number };
  pode_configurar: boolean;
  pode_transmitir: boolean;
}

export interface ISimulacao {
  competencia: string;
  alvos: { empresa_id: number; nome: string }[];
  puladas: { empresa_id: number; nome: string; motivo: string }[];
}

export interface IEmpresaAutomacao {
  empresa_id: number;
  nome: string;
  external_id: string | null;
  fiscal: string | null;
  automacao: Automacao;
  situacao: string | null;
  fatura_pendente: boolean;
  trava: string | null;
}

/** Rotinas que aceitam rodar em todas as empresas (não aprovam nem transmitem). */
export const ROTINAS_ESCOPO_TODAS = ['recalcular', 'buscar_rbt12'];

export const ROTULO_AUTOMACAO: Record<Automacao, string> = {
  manual: 'Manual',
  calcular: 'Só calcular',
  transmitir: 'Calcular e transmitir',
};

const dados = <T>(r: { data: { data: T } }) => r.data.data;

export const agApi = {
  modulo: (modulo: Modulo) => api.get(`${BASE}/${modulo}`).then(dados<IModuloAgendamentos>),
  salvarChave: (modulo: Modulo, ligado: boolean) =>
    api.put(`${BASE}/${modulo}/chave`, { ligado }).then(dados<{ ligado: boolean }>),
  salvarRotina: (
    id: number,
    body: { ativo: boolean; dias: string; hora: string; opcoes?: IRotina['opcoes'] },
  ) => api.put(`${BASE}/rotina/${id}`, body).then(dados<{ id: number; ativo: boolean }>),
  simular: (id: number) => api.post(`${BASE}/rotina/${id}/simular`).then(dados<ISimulacao[]>),
  executar: (id: number) =>
    api.post(`${BASE}/rotina/${id}/executar`).then(dados<{ task_id: string }>),
  execucoes: (modulo: Modulo, rotina?: string) =>
    api
      .get(`${BASE}/${modulo}/execucoes`, { params: { rotina, limite: 50 } })
      .then(dados<IExecucao[]>),
  execucao: (id: number) => api.get(`${BASE}/execucao/${id}`).then(dados<IExecucao>),
  empresas: () => api.get(`${BASE}/simples_nacional/empresas`).then(dados<IEmpresaAutomacao[]>),
  salvarEmpresas: (empresaIds: number[], automacao: Automacao) =>
    api
      .put(`${BASE}/simples_nacional/empresas`, { empresa_ids: empresaIds, automacao })
      .then(dados<{ alteradas: number }>),
};

export const mensagemErro = (e: any): string => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x: any) => x?.msg ?? String(x)).join('; ');
  return e?.message ?? 'Erro inesperado';
};
